export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Twoje zamówienie zostało odebrane',
    order_confirmed: '#{{number}} Potwierdzony czas {{time}}',
    order_preparation_up_time_changed: '#{{number}} Czas {{type}} zmieniony na {{time}}',
    serving_time_changed: '#{{number}} Twoje zamówienie zostanie podane o {{time}}',
    order_preparing: 'Twoje zamówienie #{{number}} jest przygotowywane',
    order_rejected: '#{{number}} zamówienie odrzucone',
  },
  order_type: {
    pickup: 'Odbiór',
    delivery: 'Dostawa',
  },
};
